import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

//Bootstrap
import "react-bootstrap/dist/react-bootstrap.min.js";
import "../src/css/bootstrap.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
